module.exports = __webpack_public_path__ + "img/banner03.a45385a9.jpg";